import * as React from "react";

export const SvgJetOneSuites = (props) => (
	<svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g>
			<path
				d="M.5 6.408c-.009.197.08.384.24.501l2.826 2.087a1.752 1.752 0 0 0 1.896.108c.656-.383 6.868-3.88 7.285-4.107a3.216 3.216 0 0 0 1.6-2.052c.043-.156.078-.302.112-.448a1.45 1.45 0 0 0-.163-1.117 1.457 1.457 0 0 0-.9-.675L13.28.678c-.1-.024-.204-.049-.327-.083a3.267 3.267 0 0 0-2.585.45c-.116.078-.623.464-1.302.987-.512-.187-2.377-.867-3.263-1.187a1.336 1.336 0 0 0-1.475.34c-.233.244-.456.512-.456.512a.587.587 0 0 0 .098.847l2.249 1.694-1.803 1.404-1.298-.652a.789.789 0 0 0-.795.016l-1.538.925a.588.588 0 0 0-.284.477Zm4.69-4.42a.178.178 0 0 1 .196-.04c.647.232 1.793.65 2.578.935l-.781.606-1.992-1.5ZM2.752 6.124l1.469.738a.593.593 0 0 0 .627-.06c2.327-1.817 5.892-4.586 6.173-4.774a2.08 2.08 0 0 1 1.629-.295c.118.034.241.064.454.114.077.02.14.066.185.144.04.062.05.14.031.213 0 .004-.068.287-.111.446a2.044 2.044 0 0 1-1.02 1.311c-.423.23-6.66 3.742-7.316 4.125a.56.56 0 0 1-.61-.04L2.15 6.487l.602-.363ZM19.5 18.792V7.568a.59.59 0 0 0-.589-.589h-7.656a.589.589 0 0 0-.589.59v2.494l-9.612 2.83a.589.589 0 0 0-.423.564v5.335c0 .325.264.589.59.589h17.69a.589.589 0 0 0 .589-.59ZM1.81 13.898l8.856-2.607v6.912H1.81v-4.305Zm16.512 4.305h-6.478V8.157h6.478v10.046Zm-1.8-4.157h-2.879v-1.178h2.88v1.178Zm0 2.356h-2.879v-1.178h2.88v1.178Zm0-4.712h-2.879v-1.177h2.88v1.178Z"
				fill={props.color ?? "#A8A8A8"}
				stroke={props.color ?? "#A8A8A8"}
				strokeWidth={0.1}
			/>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M0 0h20v20H0z" />
			</clipPath>
		</defs>
	</svg>
);
